import React from 'react';
import { AiOutlineForm } from 'react-icons/ai';


const Divorcios = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Requisitos para Divorcios </h1>

                <ul className='list-disc list-inside text-xl font-sans'>
                    <li>Registros civiles de nacimiento con notas marginales de matrimonio</li>
                    <li>Registro de matrimonio</li>
                    <li>Fotocopias de las cédulas ampliadas</li>
                    <li>Registros civiles de los hijos</li>
                    <li>Si hay bienes: Certificados de tradición  y cámara y comercio</li>
                </ul>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Divorcios.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>
            </div>
        </div>

    );
}

export default Divorcios;